import React from 'react'
import ResponsiveAppBar from './ResponsiveAppBar'
import { useScrollTrigger, Fade, Tooltip, Box, Fab, Toolbar, IconButton } from '@mui/material';
import { ArrowUpward, ContactPage, QrCodeScanner } from '@mui/icons-material';
import ContactQr from './ContactQr';
import { Link, useNavigate } from 'react-router-dom';
import iaLogo from "../Files/ia.png"

interface Props {
    /**
     * Injected by the documentation to work in an iframe.
     * You won't need it on your project.
     */
    window?: () => Window;
    children?: React.ReactElement;
}

function Header(props: Props) {
    const { } = props
    const navigate = useNavigate()
    const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
        const anchor = (
            (event.target as HTMLDivElement).ownerDocument || document
        ).querySelector('#back-to-top-anchor');

        if (anchor) {
            anchor.scrollIntoView({
                block: 'center',
                behavior: "smooth"
            });
        }
    };

    function ScrollTop(props: Props) {
        const { children, window } = props;
        const trigger = useScrollTrigger({
            target: window ? window() : undefined,
            disableHysteresis: true,
            threshold: 100,
        });


        return (
            <Fade in={trigger}>
                <Tooltip title="Remonter en haut de la page">
                    <Box
                        onClick={handleClick}
                        role="presentation"
                        sx={{ position: 'fixed', bottom: 150, right: 20 }}
                    >
                        {children}
                    </Box>
                </Tooltip>
            </Fade>
        );
    }

    return (
        <div>
            <Toolbar id="back-to-top-anchor" >
                <ResponsiveAppBar />
                <Box zIndex={1}>
                    <ScrollTop {...props}>
                        <Fab style={{ backgroundColor: "white" }} color='inherit' size="small" aria-label="scroll back to top">
                            <ArrowUpward style={{ color: "#13367d" }} />
                        </Fab>
                    </ScrollTop>
                </Box>
            </Toolbar>
            <ContactQr />
            {window.location.pathname !== '/focusia/chat' ?<Box sx={{ visibility: { xs: 'visible', md: 'hidden' } }}>
                <Fab style={{ position: 'fixed', bottom: 50, left: 20, backgroundColor: "white" }}>
                    <Tooltip title={"FOCUS IA CHAT"}><IconButton onClick={(e: any) => { navigate("/focusia/chat"); handleClick(e) }} style={{ color: "#164F7D" }}> <img src={iaLogo} alt="" width={40} /> </IconButton></Tooltip>
                </Fab>
            </Box>
            : ""}


        </div>
    )
}

export default Header
